import { render, staticRenderFns } from "./AllInsurances.vue?vue&type=template&id=3732beb6&"
import script from "./AllInsurances.vue?vue&type=script&lang=js&"
export * from "./AllInsurances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports